<template>
  <div class="d-flex align-items-center">
    <b-popover target="contactsDetails" placement="bottom">
      <p class="contacts__text">{{$t('labels.common.contact_details')}}</p>
      <p class="contacts__text"><a target="_blank" :href="SERVICE_DESK_URL">Service Desk</a></p>
    </b-popover>
    <icon
      id="contactsDetails"
      name="phone-square"
      class="contacts__icon"/>
  </div>
</template>
<script>
import { SERVICE_DESK_URL } from '@/constants'

export default {
  data () {
    return {
      SERVICE_DESK_URL
    }
  }
}
</script>

<style lang="scss" scoped>
  .contacts__icon {
    width: 26px;
    height: 26px;
    color: #364868;
    margin: 0 15px;
    cursor: pointer;
  }

  .contacts__text {
    margin-bottom: 0.5rem;
    font-size: 14px;

    &:last-child {
      margin-bottom: 0;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/common/Contacts.vue